import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setIsInsertingNewColumn } from '@/redux/reducers/spreadsheetSlice';

import { get } from '@/Utils/API';
import { spreadsheetSliceName, userDataSliceName } from '@/redux/constants';
import showToast from '@/Components/Toast/showToastTemplate';
import { GENERAL_ERROR_TEXT, OPERATION_STATUSES, TOAST_TYPE_ERROR } from '@/Utils/constants';
import { getFileUuidFromPath } from '@/Utils/getFileUuidFromPath';
import { operationStatusEndpoint } from '@/Utils/apiEndpoints';

function useJobStatusPolling() {
  const uuid = getFileUuidFromPath();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state[userDataSliceName]);
  const { isInsertingNewColumn } = useSelector((state) => state[spreadsheetSliceName]);
  const [pollingTimeout, setPollingTimeout] = useState(null);
  let requestCount = 0;

  const checkOperationStatus = async () => {
    if (user?.is_anonymous) return;
    requestCount++;
    try {
      const endpoint = operationStatusEndpoint(uuid);
      const response = await get(endpoint);

      if (response.Status === OPERATION_STATUSES.DONE) {
        dispatch(setIsInsertingNewColumn(false));
        clearTimeout(pollingTimeout);
      } else if (response.Status === OPERATION_STATUSES.ERROR) {
        requestCount > 1 &&
          showToast({
            type: TOAST_TYPE_ERROR,
            text: response.Message || GENERAL_ERROR_TEXT,
            errorContext: response,
            endpoint: endpoint,
            fileAndFunction: '__FILE_AND_FUNCTION_NAME__',
          });
        clearTimeout(pollingTimeout);
        dispatch(setIsInsertingNewColumn(false));
      } else if (response.Status === OPERATION_STATUSES.WORKING) {
        dispatch(setIsInsertingNewColumn(true));
        const timeout = setTimeout(checkOperationStatus, 5000);
        setPollingTimeout(timeout);
      }
    } catch (error) {
      clearTimeout(pollingTimeout);
      console.error('Error checking operation status:', error);
    }
  };

  useEffect(() => {
    checkOperationStatus();
    return () => clearTimeout(pollingTimeout);
  }, []);

  return { isInsertingNewColumn };
}

export default useJobStatusPolling;
